
  var sku_values_l = ''; //Valor de todas las combinaciones colocadas en el ojo izquierdo
  var sku_values_r = ''; //Valor de todas las combinaciones colocadas en el ojo derecho
  var var_l_sph = ''; //Este es el valor del SPH en el ojo izquierdo
  var var_r_sph = ''; //Este es el valor del SPH en el ojo derecho

$('#right-upc input, #left-upc input').val(val_upc);  
	
$('#left-graduacion').click(function() {
    var_l_sph = $('#4082599985230_option_3').val();
	console.log(var_l_sph); 
	unify_values_l();
	fetch_sku_l();
});


$('#right-graduacion').click(function() {
    var_r_sph = $('#4082599985230_option_4').val();
	console.log(var_r_sph); 
	unify_values_r();
	fetch_sku_r();
});


function unify_values_l(){
	sku_values_l = var_l_sph ;
	console.log(sku_values_l);
}

function unify_values_r(){
	sku_values_r = var_r_sph;
	console.log(sku_values_r);
}


function fetch_sku_l(){
 	switch (sku_values_l) { 
case '-0.50' : $('#left-sku input').val('810015'); break;
case '+0.50' : $('#left-sku input').val('810022'); break;
case '-0.75' : $('#left-sku input').val('810039'); break;
case '+0.75' : $('#left-sku input').val('810046'); break;
case '-1.00' : $('#left-sku input').val('810053'); break;
case '+1.00' : $('#left-sku input').val('810060'); break;
case '-1.25' : $('#left-sku input').val('810077'); break;
case '+1.25' : $('#left-sku input').val('810084'); break;
case '-1.50' : $('#left-sku input').val('810091'); break;
case '+1.50' : $('#left-sku input').val('810107'); break;
case '-1.75' : $('#left-sku input').val('810114'); break;
case '+1.75' : $('#left-sku input').val('810121'); break;
case '-2.00' : $('#left-sku input').val('810138'); break;
case '+2.00' : $('#left-sku input').val('810145'); break;
case '-2.25' : $('#left-sku input').val('810152'); break;
case '+2.25' : $('#left-sku input').val('810169'); break;
case '-2.50' : $('#left-sku input').val('810176'); break;
case '+2.50' : $('#left-sku input').val('810183'); break;
case '-2.75' : $('#left-sku input').val('810190'); break;
case '+2.75' : $('#left-sku input').val('810206'); break;
case '-3.00' : $('#left-sku input').val('810213'); break;
case '+3.00' : $('#left-sku input').val('810220'); break;
case '-3.25' : $('#left-sku input').val('810237'); break;
case '+3.25' : $('#left-sku input').val('810244'); break;
case '-3.50' : $('#left-sku input').val('810251'); break;
case '+3.50' : $('#left-sku input').val('810268'); break;
case '-3.75' : $('#left-sku input').val('810275'); break;
case '+3.75' : $('#left-sku input').val('810282'); break;
case '-4.00' : $('#left-sku input').val('810299'); break;
case '+4.00' : $('#left-sku input').val('810305'); break;
case '-4.25' : $('#left-sku input').val('810312'); break;
case '+4.25' : $('#left-sku input').val('810329'); break;
case '-4.50' : $('#left-sku input').val('810336'); break;
case '+4.50' : $('#left-sku input').val('810343'); break;
case '-4.75' : $('#left-sku input').val('810350'); break;
case '+4.75' : $('#left-sku input').val('810367'); break;
case '-5.00' : $('#left-sku input').val('810374'); break;
case '+5.00' : $('#left-sku input').val('810381'); break;
case '-5.25' : $('#left-sku input').val('810398'); break;
case '+5.25' : $('#left-sku input').val('810404'); break;
case '-5.50' : $('#left-sku input').val('810411'); break;
case '+5.50' : $('#left-sku input').val('810428'); break;
case '-5.75' : $('#left-sku input').val('810435'); break;
case '+5.75' : $('#left-sku input').val('810442'); break;
case '-6.00' : $('#left-sku input').val('810459'); break;
case '+6.00' : $('#left-sku input').val('810466'); break;
case '-6.50' : $('#left-sku input').val('810473'); break;
case '+6.50' : $('#left-sku input').val('810480'); break;
case '-7.00' : $('#left-sku input').val('810497'); break;
case '+7.00' : $('#left-sku input').val('810503'); break;
case '-7.50' : $('#left-sku input').val('810510'); break;
case '+7.50' : $('#left-sku input').val('810527'); break;
case '-8.00' : $('#left-sku input').val('810534'); break;
case '+8.00' : $('#left-sku input').val('810541'); break;
case '-8.50' : $('#left-sku input').val('810558'); break;
case '-9.00' : $('#left-sku input').val('810572'); break;
case '-9.50' : $('#left-sku input').val('810596'); break;
case '-10.00' : $('#left-sku input').val('810619'); break;
case '-10.50' : $('#left-sku input').val('810633'); break;
case '-11.00' : $('#left-sku input').val('810657'); break;
case '-11.50' : $('#left-sku input').val('810671'); break;
case '-12.00' : $('#left-sku input').val('810695'); break;


 	    default:
        $('#left-sku input').val('SKU Desconocido');
    }
}//fetch_sku()



function fetch_sku_r(){
 	switch (sku_values_r) {
case '-0.50' : $('#right-sku input').val('810015'); break;
case '+0.50' : $('#right-sku input').val('810022'); break;
case '-0.75' : $('#right-sku input').val('810039'); break;
case '+0.75' : $('#right-sku input').val('810046'); break;
case '-1.00' : $('#right-sku input').val('810053'); break;
case '+1.00' : $('#right-sku input').val('810060'); break;
case '-1.25' : $('#right-sku input').val('810077'); break;
case '+1.25' : $('#right-sku input').val('810084'); break;
case '-1.50' : $('#right-sku input').val('810091'); break;
case '+1.50' : $('#right-sku input').val('810107'); break;
case '-1.75' : $('#right-sku input').val('810114'); break;
case '+1.75' : $('#right-sku input').val('810121'); break;
case '-2.00' : $('#right-sku input').val('810138'); break;
case '+2.00' : $('#right-sku input').val('810145'); break;
case '-2.25' : $('#right-sku input').val('810152'); break;
case '+2.25' : $('#right-sku input').val('810169'); break;
case '-2.50' : $('#right-sku input').val('810176'); break;
case '+2.50' : $('#right-sku input').val('810183'); break;
case '-2.75' : $('#right-sku input').val('810190'); break;
case '+2.75' : $('#right-sku input').val('810206'); break;
case '-3.00' : $('#right-sku input').val('810213'); break;
case '+3.00' : $('#right-sku input').val('810220'); break;
case '-3.25' : $('#right-sku input').val('810237'); break;
case '+3.25' : $('#right-sku input').val('810244'); break;
case '-3.50' : $('#right-sku input').val('810251'); break;
case '+3.50' : $('#right-sku input').val('810268'); break;
case '-3.75' : $('#right-sku input').val('810275'); break;
case '+3.75' : $('#right-sku input').val('810282'); break;
case '-4.00' : $('#right-sku input').val('810299'); break;
case '+4.00' : $('#right-sku input').val('810305'); break;
case '-4.25' : $('#right-sku input').val('810312'); break;
case '+4.25' : $('#right-sku input').val('810329'); break;
case '-4.50' : $('#right-sku input').val('810336'); break;
case '+4.50' : $('#right-sku input').val('810343'); break;
case '-4.75' : $('#right-sku input').val('810350'); break;
case '+4.75' : $('#right-sku input').val('810367'); break;
case '-5.00' : $('#right-sku input').val('810374'); break;
case '+5.00' : $('#right-sku input').val('810381'); break;
case '-5.25' : $('#right-sku input').val('810398'); break;
case '+5.25' : $('#right-sku input').val('810404'); break;
case '-5.50' : $('#right-sku input').val('810411'); break;
case '+5.50' : $('#right-sku input').val('810428'); break;
case '-5.75' : $('#right-sku input').val('810435'); break;
case '+5.75' : $('#right-sku input').val('810442'); break;
case '-6.00' : $('#right-sku input').val('810459'); break;
case '+6.00' : $('#right-sku input').val('810466'); break;
case '-6.50' : $('#right-sku input').val('810473'); break;
case '+6.50' : $('#right-sku input').val('810480'); break;
case '-7.00' : $('#right-sku input').val('810497'); break;
case '+7.00' : $('#right-sku input').val('810503'); break;
case '-7.50' : $('#right-sku input').val('810510'); break;
case '+7.50' : $('#right-sku input').val('810527'); break;
case '-8.00' : $('#right-sku input').val('810534'); break;
case '+8.00' : $('#right-sku input').val('810541'); break;
case '-8.50' : $('#right-sku input').val('810558'); break;
case '-9.00' : $('#right-sku input').val('810572'); break;
case '-9.50' : $('#right-sku input').val('810596'); break;
case '-10.00' : $('#right-sku input').val('810619'); break;
case '-10.50' : $('#right-sku input').val('810633'); break;
case '-11.00' : $('#right-sku input').val('810657'); break;
case '-11.50' : $('#right-sku input').val('810671'); break;
case '-12.00' : $('#right-sku input').val('810695'); break;


 		default:
        $('#right-sku input').val('SKU Desconocido');
    }
}//fetch_sku()


